import dynamic from 'next/dynamic';

import { createImage } from '@/lib/utils/createImageObject';
import { resolvePageSlug } from '@/lib/utils/dynamicPageSlug';

import {
  WIDGET_TEMPLATES as TEMPLATES,
  WIDGET_TYPES as TYPES,
} from './constants';

import type { WidgetPlugin } from './types';
import type { CTASpotlightBannerProps } from '@/components/molecules';

import type { Page, SiteConfigResponse, Widget } from '@/lib/api/types';

export const SpotlightBannerPlugin: WidgetPlugin<CTASpotlightBannerProps> = {
  type: TYPES.IMAGE_BANNER,
  template: TEMPLATES.SPOTLIGHT,
  component: dynamic(() =>
    import('@/components/molecules').then(mod => mod.CTASpotlightBanner),
  ),
  mapProps: (
    widget: Widget,
    siteData?: {
      site: SiteConfigResponse;
      pages: Page[];
    },
  ) => {
    const href = resolvePageSlug(
      siteData?.pages || [],
      widget.content_parameters,
    );

    return {
      title: widget.title,
      href,
      contentType: widget.content_parameters.content_type || '',
      content: Array.isArray(widget.template.parameters)
        ? ''
        : (widget.template.parameters?.short_description ?? ''),
      imageUrl: Array.isArray(widget.template.parameters)
        ? createImage()
        : createImage(widget.template.parameters?.image),
      primaryButtonText: Array.isArray(widget.template.parameters)
        ? ''
        : (widget.template?.parameters?.cta_title ?? ''),
    };
  },
};
